import { computed, ref } from 'vue'
import { nextSortState, sortParams } from '../utils/sort'
import type { SortDirection, SortState } from '../utils/sort'

export interface UseListSort {
  sort: import('vue').Ref<SortState>
  sortState: import('vue').Ref<SortState>
  params: import('vue').ComputedRef<Record<string, string>>
  toggle: (field: string) => void
  set: (field: string, direction: SortDirection) => void
  reset: () => void
}

export function useListSort(initial?: Partial<SortState>): UseListSort {
  const sort = ref<SortState>({
    field: initial?.field ?? null,
    direction: initial?.direction ?? null
  })

  const params = computed(() => sortParams(sort.value) as Record<string, string>)

  function toggle(field: string) {
    sort.value = nextSortState(sort.value, field)
  }

  function set(field: string, direction: SortDirection) {
    sort.value = { field, direction }
  }

  function reset() {
    sort.value = { field: null, direction: null }
  }

  return { sort, sortState: sort, params, toggle, set, reset }
}

export type { SortDirection, SortState }
